import Phaser from "phaser";
import { store } from "../state/StateStore";

export class UIHudSystem {
  private scene: Phaser.Scene;
  private scoreText: Phaser.GameObjects.Text | null = null;
  private comboText: Phaser.GameObjects.Text | null = null;
  private stageText: Phaser.GameObjects.Text | null = null;
  private scorePopup: Phaser.GameObjects.Text | null = null;
  private unsubscribe: (() => void) | null = null;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  /** Create HUD elements */
  create(): void {
    const { width } = this.scene.cameras.main;

    // Score text
    this.scoreText = this.scene.add.text(20, 20, "Score: 0", {
      fontSize: "24px",
      color: "#ffffff",
      fontFamily: "Arial, sans-serif",
      fontStyle: "bold",
    });
    this.scoreText.setDepth(200);

    // Combo text
    this.comboText = this.scene.add.text(20, 52, "", {
      fontSize: "18px",
      color: "#ffdd00",
      fontFamily: "Arial, sans-serif",
      fontStyle: "bold",
    });
    this.comboText.setDepth(200);

    // Stage text
    this.stageText = this.scene.add.text(width - 20, 20, "Stage 1", {
      fontSize: "20px",
      color: "#ffffff",
      fontFamily: "Arial, sans-serif",
      fontStyle: "bold",
      align: "right",
    });
    this.stageText.setOrigin(1, 0);
    this.stageText.setDepth(200);

    // Subscribe to state changes
    this.unsubscribe = store.subscribe((state) => {
      if (this.scoreText) {
        this.scoreText.setText(`Score: ${state.score}`);
      }
      if (this.comboText) {
        if (state.combo > 1) {
          this.comboText.setText(`${state.combo}x Combo!`);
          this.comboText.setAlpha(1);
        } else {
          this.comboText.setAlpha(0);
        }
      }
      if (this.stageText) {
        this.stageText.setText(`Stage ${state.stage}`);
      }
    });
  }

  /** Show score popup animation */
  showScorePopup(score: number, x: number, y: number): void {
    const popup = this.scene.add.text(x, y, `+${score}`, {
      fontSize: "28px",
      color: "#00ff88",
      fontFamily: "Arial, sans-serif",
      fontStyle: "bold",
      stroke: "#000000",
      strokeThickness: 3,
    });
    popup.setOrigin(0.5);
    popup.setDepth(200);

    this.scene.tweens.add({
      targets: popup,
      y: y - 60,
      alpha: 0,
      duration: 800,
      ease: "Power2",
      onComplete: () => popup.destroy(),
    });
  }

  /** Show combo text animation */
  showComboAnimation(): void {
    if (this.comboText) {
      this.scene.tweens.add({
        targets: this.comboText,
        scaleX: 1.3,
        scaleY: 1.3,
        duration: 150,
        yoyo: true,
        ease: "Power2",
      });
    }
  }

  /** Destroy HUD */
  destroy(): void {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
    this.scoreText?.destroy();
    this.comboText?.destroy();
    this.stageText?.destroy();
    this.scorePopup?.destroy();
  }
}
